import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-html-video-tag',
  templateUrl: './html-video-tag.component.html',
  styleUrls: ['./html-video-tag.component.css']
})
export class HtmlVideoTagComponent implements OnInit {
  @Input() videoData : any;
  videoPath: any;
  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(){
    this.videoPath = this.videoData.path
  }

}
